import React from "react";
import PropTypes from "prop-types";
import makeStyles from "@mui/styles/makeStyles";
import RadioGroup from "@mui/material/RadioGroup";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "@limitless/common/hooks";
import RadioButton from "../../inputs/radio-button/RadioButton";
import { aiStar } from "@limitless/images";
import { Grid } from "@mui/material";
const useStyles = makeStyles(() => ({
  radioLabel: {
    marginRight: "63px !important",
    display: "flex",
    alignItems: "center"
  },
  icon: {
    cursor: "pointer"
  },
  radioLabelWithAI: {
    marginRight: "43px !important",
    display: "flex",
    alignItems: "center"
  }
}));
const BinaryRatings = ({
  onClick,
  disabled,
  value,
  aiUpdated,
  reasoning,
  aiGeneratedScore,
  onChange
}) => {
  const classes = useStyles();
  const {
    t
  } = useTranslation();
  const commonToolTipContent = () => {
    return /*#__PURE__*/React.createElement(Tooltip, {
      title: reasoning
    }, /*#__PURE__*/React.createElement("img", {
      src: aiStar,
      alt: "AI Star",
      className: classes.icon,
      style: {
        width: 20,
        height: 20
      }
    }));
  };
  return /*#__PURE__*/React.createElement(RadioGroup, {
    row: true,
    onChange: (event, newValue) => onClick(newValue),
    value: value
  }, /*#__PURE__*/React.createElement(Grid, {
    className: aiUpdated && aiGeneratedScore === 1 ? classes.radioLabelWithAI : classes.radioLabel
  }, /*#__PURE__*/React.createElement(RadioButton, {
    disabled: disabled,
    value: 1,
    label: t("Yes"),
    componentsProps: {
      typography: {
        variant: "body2",
        color: theme => theme.palette.info.contrastText
      }
    }
  }), aiUpdated && aiGeneratedScore === 1 && commonToolTipContent()), /*#__PURE__*/React.createElement(Grid, {
    className: classes.radioLabel
  }, /*#__PURE__*/React.createElement(RadioButton, {
    disabled: disabled,
    value: 0,
    label: t("No"),
    componentsProps: {
      typography: {
        variant: "body2",
        color: theme => theme.palette.info.contrastText
      }
    }
  }), aiUpdated && aiGeneratedScore === 0 && commonToolTipContent()));
};
BinaryRatings.propTypes = {
  onClick: PropTypes.func.isRequired,
  value: PropTypes.number,
  disabled: PropTypes.bool,
  aiUpdated: PropTypes.bool,
  reasoning: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  aiGeneratedScore: PropTypes.number
};
export default BinaryRatings;